import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to the top of the page on every route change. Without this, React Router keeps
// the previous scroll position, so navigating from a scrolled page loads the next one
// already scrolled down. Hash links (#section) are left alone so anchor scrolling works.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let in-page anchor links (#services, #in-person) scroll themselves
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
